import React from 'react';
import { useIntl } from 'react-intl';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PersonOutlineIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FmdBadOutlinedIcon from '@mui/icons-material/FmdBadOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const IncomingCallDetails = function IncomingCallDetails({
  show = false,
  customerData = {},
  goToCustomerPage = () => {},
}) {
  const intl = useIntl();

  const details = [
    {
      icon: <PersonOutlineIcon fontSize="small" />,
      label: intl.messages.FULLNAME,
      value: customerData?.entityFullName || intl.messages.UNAVAILABLE,
    },
    {
      icon: <LocalPhoneOutlinedIcon fontSize="small" />,
      label: intl.messages.PHONE,
      value: customerData?.calling || intl.messages.UNAVAILABLE,
    },
  ];

  const branchMismatch =
    customerData?.assignedBranchId &&
    customerData?.assignedBranchId !== customerData?.branchId;

  return (
    <Collapse in={show} timeout="auto" unmountOnExit>
      {branchMismatch ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            m: '8px 16px 0',
            p: '8px 12px',
            borderRadius: '8px',
            backgroundColor: 'rgba(255, 167, 38, 0.15)',
          }}
        >
          <FmdBadOutlinedIcon
            color="warning"
            fontSize="small"
            sx={{ flexShrink: 0 }}
          />
          <Typography variant="caption" sx={{ lineHeight: 1.3 }}>
            {`${intl.messages.ASSIGNEDBRANCH}: ${customerData?.assignedBranch}`}
          </Typography>
        </Box>
      ) : null}
      <Stack
        divider={
          <Divider flexItem sx={{ borderColor: 'rgba(255, 255, 255, 0.15)' }} />
        }
        sx={{ p: '8px 16px 0' }}
      >
        {details.map(({ icon, label, value }) => (
          <Box
            key={label}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              py: '8px',
            }}
          >
            {icon}
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="caption"
                sx={{ display: 'block', opacity: 0.7, lineHeight: 1.2 }}
              >
                {label}
              </Typography>
              <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
                {value}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
          p: '8px',
        }}
      >
        <Button
          size="small"
          variant="outlined"
          sx={{ borderColor: 'white.main', color: 'white.main' }}
          endIcon={<ArrowForwardIcon />}
          onClick={goToCustomerPage}
        >
          {intl.messages.CUSTOMER_PAGE}
        </Button>
      </Box>
    </Collapse>
  );
};

export default IncomingCallDetails;
